import React from 'react';

import classNames from 'classnames';

import LoadingSpinner from 'CommonComponents/LoadingSpinner';

export default function Button({ children, variant, small, loading, className, as, ...props }) {
    const Tag = as || 'button';

    return (
        <Tag
            type={Tag === 'button' ? 'button' : null}
            {...props}
            className={classNames(className, 'button', {
                primary: variant === 'primary',
                secondary: variant === 'secondary',
                danger: variant === 'danger',
                success: variant === 'success',
                outline: variant === 'outline',
                'outline-danger': variant === 'outline-danger',
                'outline-neutral': variant === 'outline-neutral',
                small,
            })}
        >
            {loading && <LoadingSpinner ySpacing={false} size="xs" />}
            {children}
        </Tag>
    );
}
